import * as React from 'react';
import {
  Box,
  UtilityText,
  StackLayout,
  Divider,
  Icon,
  ParagraphText,
} from '@leagueplatform/genesis-core';
import {
  ActionIconSvg,
  DecisionIconSvg,
  EndIconSvg,
  StartIconSvg,
} from '@web-config-app/core-react-ui';
import type { DetailNodeType, NodeType } from '../../types';
import { nodeWidth } from '../../constants';
import { useFlowContext } from '../../context/flow-context';

export const typeIcons: Record<NodeType, React.ReactNode> = {
  action: <ActionIconSvg />,
  decision: <DecisionIconSvg />,
  end: <EndIconSvg />,
  start: <StartIconSvg />,
};

export const DetailNode = ({
  label,
  type,
  id,
}: {
  label: string;
  id: string;
  type: DetailNodeType;
}) => {
  const { nodeTypeLabelMap } = useFlowContext();
  const typeLabel = nodeTypeLabelMap[type];

  return (
    <StackLayout
      css={{
        background: '$surfaceBackgroundPrimary',
        border: `solid $onSurfaceBorderSubdued`,
        borderWidth: '$thin',
        borderRadius: '$medium',
        width: nodeWidth[type],
        spacing: '$none',
      }}
    >
      <StackLayout
        orientation="horizontal"
        verticalAlignment="center"
        horizontalAlignment="spaceBetween"
        css={{
          width: '100%',
          backgroundColor: '$surfaceBackgroundSecondary',
          padding: '$threeQuarters',
          borderStartStartRadius: '$medium',
          borderStartEndRadius: '$medium',
        }}
      >
        <UtilityText size="eyebrow">{typeLabel}</UtilityText>
        <Icon icon={typeIcons[type]} tint="$onSurfaceIconPrimary" />
      </StackLayout>
      <Divider css={{ margin: '$none' }} />
      <Box css={{ padding: '$threeQuarters' }}>
        <ParagraphText>{label}</ParagraphText>
        <UtilityText size="xs">{id}</UtilityText>
      </Box>
    </StackLayout>
  );
};
